export default __webpack_public_path__ + "static/media/newsletter.6b7fe8b8.png";